import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DipRegistrationContextService} from '../../core/services/dip-registration-context.service';
import { DiprsSpaLoggerService } from '../../core/services/logger/diprs-spa-logger.service';
import { DipRegistrationNavigationService } from '../../core/services/dip-registration-navigation.service';
import { DipRegistrationLoggingNames } from '../../core/enum/dip-registration-logging-names.enum';
import { LoggerEventEnum } from '../../core/models/dip-registration-log-information.model';
import {WebMetricsService} from '../../core/services/web-metrics/web-metrics.service';

@Component({
    selector: 'dip-registration-page-not-found-error',
    templateUrl: './dip-registration-page-not-found-error.component.html',
    styleUrls: ['./dip-registration-page-not-found-error.component.scss'],
    standalone: false
})
export class DipRegistrationPageNotFoundErrorComponent implements OnInit, OnDestroy {

  errorCode: string;
  errorMessage: string;
  errorTitle: string;
  phoneNumber: string;
  version: string;
  sessionId: string;

  constructor(private route: ActivatedRoute,
              private dipRegistrationContextService: DipRegistrationContextService,
              private webMetricsService: WebMetricsService,
              private dipRegistrationNavigationService: DipRegistrationNavigationService,
              private spaLoggerService: DiprsSpaLoggerService) {
  }

  ngOnInit() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_ENTERED, DipRegistrationLoggingNames.PAGE_NOT_FOUND, { previousPageId: this.dipRegistrationNavigationService.getPreviousUrl() });
    this.webMetricsService.submitErrorAndWarningTag('404');

    this.dipRegistrationContextService.resetContextFlag();

    this.sessionId = this.dipRegistrationContextService.getSessionId();
    this.version = this.dipRegistrationContextService.getVersionId();
  }

  ngOnDestroy() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_EXITED, DipRegistrationLoggingNames.PAGE_NOT_FOUND, null);
  }
}

